module.exports = __webpack_public_path__ + "static/media/BS_O_Embroidery_Bicocca_White_DKGrey.121d9623.png";